import { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { Typography } from 'antd';
import moment from 'moment';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAppDispatch, useAppSelector, useTranslate } from 'hooks';

import { getPieceOfNews } from 'features/news/actions';
import { getUserProfile } from 'features/user/actions';

import { Loading, RejectedMessage } from 'componets/ui';

import { language } from 'utils';
import { Paths } from 'utils/constants';

import { ReactComponent as ArrowBack } from 'assets/icons/arrow-back.svg';

import styles from './index.module.scss';

interface LocationState {
	page: number;
}
export const PieceOfNews = () => {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();
	const location = useLocation();

	const state = location.state as LocationState;
	const { allNewsText } = useTranslate(['allNewsText']);
	const [isLoading, setIsLoading] = useState(true);

	const newsItem = useAppSelector((state) => state.news.newsItem);

	const [isRejected, setIsRejected] = useState(false);

	const { newsUuid } = useParams();

	useEffect(() => {
		if (newsUuid) {
			setIsLoading(true);
			dispatch(getPieceOfNews({ newsUuid, lang: language }))
				.unwrap()
				.catch(() => {
					setIsRejected(true);
				})
				.finally(() => {
					dispatch(getUserProfile());
					setIsLoading(false);
				});
		}
	}, [dispatch, newsUuid]);

	return (
		<>
			{isRejected ? (
				<RejectedMessage isNotFound />
			) : isLoading ? (
				<Loading />
			) : (
				<div className={styles.root}>
					<div
						role="button"
						onClick={() => {
							navigate({ pathname: Paths.NEWS, search: `?page=${state?.page || 1}` });
						}}
						className={styles.back}
					>
						<ArrowBack /> {allNewsText}
					</div>

					<Typography.Text type="secondary">
						{moment(newsItem.publishedAt).format('YYYY-MM-DD')}
					</Typography.Text>

					<div>
						<Typography.Title level={4} className={styles.title}>
							{newsItem.title}
						</Typography.Title>

						<div className={styles.body} dangerouslySetInnerHTML={{ __html: newsItem.body }} />
					</div>
				</div>
			)}
		</>
	);
};
